import { types } from "../types/types";

const initialState = {

  listFullCatalogInstitutions: [],
  listCatalogInstitutionsLevel1: [],
  listCatalogInstitutionsLevel2: [],
  listCatalogInstitutionsLevel3: [],
  listCatalogInstitutionsLevel4: [],
  listCatalogInstitutionsLevel5: [],
  listCatalogInstitutionsLevel6: [],
  objectCatalogInstitutionLevel1Selected: {},
  objectCatalogInstitutionLevel2Selected: {},
  objectCatalogInstitutionLevel3Selected: {},
  objectCatalogInstitutionLevel4Selected: {},
  objectCatalogInstitutionLevel5Selected: {},
  objectCatalogInstitutionLevel6Selected: {},

  cataloginstitutions_idLevel1: [],
  listCatalogInstitutionsLevel2: [],
  listCatalogInstitutionsLevel3: [],
  listCatalogInstitutionsLevel4: [],
  listCatalogInstitutionsLevel5: [],
  listCatalogInstitutionsLevel6: [],
  cataloginstitution_levelsSelected: {},
  objectCatalogInstitutionLevel2Selected: {},
  objectCatalogInstitutionLevel3Selected: {},
  objectCatalogInstitutionLevel4Selected: {},
  objectCatalogInstitutionLevel5Selected: {},
  objectCatalogInstitutionLevel6Selected: {},

  catalogInstitutionAllLevel6: [],

  catalogInstitution: {},
  catalogInstitutions: [],
  catalogInstitutionsP: [],
  catalogInstitutionsS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
  
  listFullCatalogInstitutionsNoLevel6: []
};
export const catalogInstitutionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOGINSTITUTION_START_LOADING_LEVEL1:
      return {
        ...state,
        listCatalogInstitutionsLevel1: action.payload,
      };

    case types.CATALOGINSTITUTION_SELECT_LEVEL1:
      return {
        ...state,
        objectCatalogInstitutionLevel1Selected: action.payload,
      };

    case types.CATALOGINSTITUTION_START_LOADING_LEVEL2:
      return {
        ...state,
        listCatalogInstitutionsLevel2: action.payload,
      };

    case types.CATALOGINSTITUTION_SELECT_LEVEL2:
      return {
        ...state,
        objectCatalogInstitutionLevel2Selected: action.payload,
      };

    case types.CATALOGINSTITUTION_START_LOADING_LEVEL3:
      return {
        ...state,
        listCatalogInstitutionsLevel3: action.payload,
      };

    case types.CATALOGINSTITUTION_SELECT_LEVEL3:
      return {
        ...state,
        objectCatalogInstitutionLevel3Selected: action.payload,
      };

    case types.CATALOGINSTITUTION_START_LOADING_LEVEL4:
      return {
        ...state,
        listCatalogInstitutionsLevel4: action.payload,
      };

    case types.CATALOGINSTITUTION_SELECT_LEVEL4:
      return {
        ...state,
        objectCatalogInstitutionLevel4Selected: action.payload,
      };

    case types.CATALOGINSTITUTION_START_LOADING_LEVEL5:
      return {
        ...state,
        listCatalogInstitutionsLevel5: action.payload,
      };

    case types.CATALOGINSTITUTION_SELECT_LEVEL5:
      return {
        ...state,
        objectCatalogInstitutionLevel5Selected: action.payload,
      };

    case types.CATALOGINSTITUTION_START_LOADING_LEVEL6:
      return {
        ...state,
        listCatalogInstitutionsLevel6: action.payload,
      };

    case types.CATALOGINSTITUTION_SELECT_LEVEL6:
      return {
        ...state,
        objectCatalogInstitutionLevel6Selected: action.payload,
      };

    case types.CATALOGINSTITUTION_CLEAN_LEVEL1:
      return {
        ...state,
        objectCatalogInstitutionLevel2Selected: {},
        listCatalogInstitutionsLevel2: [],
        objectCatalogInstitutionLevel3Selected: {},
        listCatalogInstitutionsLevel3: [],
        objectCatalogInstitutionLevel4Selected: {},
        listCatalogInstitutionsLevel4: [],
        objectCatalogInstitutionLevel5Selected: {},
        listCatalogInstitutionsLevel5: [],
        objectCatalogInstitutionLevel6Selected: {},
        listCatalogInstitutionsLevel6: [],
      };

    case types.CATALOGINSTITUTION_CLEAN_LEVEL2:
      return {
        ...state,
        objectCatalogInstitutionLevel3Selected: {},
        listCatalogInstitutionsLevel3: [],
        objectCatalogInstitutionLevel4Selected: {},
        listCatalogInstitutionsLevel4: [],
        objectCatalogInstitutionLevel5Selected: {},
        listCatalogInstitutionsLevel5: [],
        objectCatalogInstitutionLevel6Selected: {},
        listCatalogInstitutionsLevel6: [],
      };

    case types.CATALOGINSTITUTION_CLEAN_LEVEL3:
      return {
        ...state,
        objectCatalogInstitutionLevel4Selected: {},
        listCatalogInstitutionsLevel4: [],
        objectCatalogInstitutionLevel5Selected: {},
        listCatalogInstitutionsLevel5: [],
        objectCatalogInstitutionLevel6Selected: {},
        listCatalogInstitutionsLevel6: [],
      };

    case types.CATALOGINSTITUTION_CLEAN_LEVEL4:
      return {
        ...state,
        objectCatalogInstitutionLevel5Selected: {},
        listCatalogInstitutionsLevel5: [],
        objectCatalogInstitutionLevel6Selected: {},
        listCatalogInstitutionsLevel6: [],
      };

    case types.CATALOGINSTITUTION_CLEAN_LEVEL5:
      return {
        ...state,
        objectCatalogInstitutionLevel6Selected: {},
        listCatalogInstitutionsLevel6: [],
      };

    /* Esto no esta todavia */
    case types.CATALOGINSTITUTION_UPDATE:
      if (state.catalogInstitutionsS.length > 0) {
        return {
          ...state,
          catalogInstitutionsS: state.catalogInstitutionsS.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
          catalogInstitutionsP: state.catalogInstitutionsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      } else {
        return {
          ...state,
          catalogInstitutionsP: state.catalogInstitutionsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      }

    case types.CATALOGINSTITUTION_DELETE:
      if (state.catalogInstitutionsS.length > 0) {
        return {
          ...state,
          catalogInstitutionsS: state.catalogInstitutionsS.filter((usr) => usr.id !== action.payload),
          catalogInstitutionsP: state.catalogInstitutionsP.filter((usr) => usr.id !== action.payload),
          catalogInstitution: {},
        };
      } else {
        return {
          ...state,
          catalogInstitutionsP: state.catalogInstitutionsP.filter((usr) => usr.id !== action.payload),
          catalogInstitution: {},
        };
      }

    case types.CATALOGINSTITUTION_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogInstitutionsP: action.payload.catalogInstitutionsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOGINSTITUTION_START_SEARCH:
      return {
        ...state,
        catalogInstitutionsS: action.payload,
      };

    case types.CATALOGINSTITUTION_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogInstitutionsP: action.payload.catalogInstitutionsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOG_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogInstitutionsS: [],
      };

      /*Add */
    case types.CATALOGINSTITUTION_SELECT:
      return {
        ...state,
        catalogInstitution: action.payload,
      };

    case types.CATALOGINSTITUTION_CLEAN:
      return {
        ...state,
        catalogInstitution: {},
      };

    case types.CATALOGINSTITUTION_START_REGISTER:
      return {
        ...state,
        catalogInstitution: action.payload,
      };

    case types.CATALOGINSTITUTION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.CATALOGINSTITUTION_START_LOADING_ALL_LEVEL6:
      return {
        ...state,
        catalogInstitutionAllLevel6: action.payload,
      };

    case types.CATALOGINSTITUTION_START_LOADING_ALL:
      return {
        ...state,
        listFullCatalogInstitutions: action.payload,
      };

      case types.CATALOGINSTITUTION_START_LOADING_NO_LEVEL6:
      return {
        ...state,
        listFullCatalogInstitutionsNoLevel6: action.payload,
      };

    case types.CATALOGINSTITUTION_START_LOADING_FILTER:

      if (action.payload == null || typeof action.payload !== 'object') {
        return state;
      }

      const { cataloginstitution_level1_codes } = action.payload;

      const catalogInstitutionIdsList = cataloginstitution_level1_codes && cataloginstitution_level1_codes.split(",");

      return {
        ...state,

        listInstitutionsFilter: getFilterCatalog(state.listCatalogInstitutionsLevel1, catalogInstitutionIdsList),

      };

    default:
      return state;
  }
};

const getFilterCatalog = (arrayFull, uniqueArray) => {
  
  let listFilterCatalog = [];

  if (uniqueArray) {

    for (const idUniqueFound of uniqueArray) {
      
      for (const elemSearch of arrayFull) {
        
        const codeFirstLetter = elemSearch.code && elemSearch.code.substring(0, 1);
        if (idUniqueFound === codeFirstLetter) {
          
          elemSearch.isChecked = false;
          listFilterCatalog.push(elemSearch);
        }
      }
    }
  }

  listFilterCatalog.sort((a, b) => a.id - b.id)

  return listFilterCatalog;
}